import type { PossibleDuplicate } from '@pet/shared';
import { formatCentsAsDollars } from '../../lib/money';
import styles from '../AddSpending.module.css';

// The possible-duplicate warning (AD-20), shown after Confirm & Save when the server finds a saved
// payment that looks like this one. It warns and never refuses: Save anyway saves the entry as it
// stands, and Go back returns to Review & Save with nothing saved.

export interface DuplicateWarningScreenProps {
  matches: PossibleDuplicate[];
  onBack: () => void;
  onSaveAnyway: () => void;
}

export default function DuplicateWarningScreen(props: DuplicateWarningScreenProps) {
  return (
    <main className={styles.container}>
      <h2 className={styles.question}>This may already be saved</h2>
      <div className={styles.summaryList}>
        {props.matches.flatMap((m) => {
          const day = m.date.slice(0, 10);
          return m.reasons.map((reason) => (
            <p key={`${m.paymentId}-${reason}`} className={styles.summaryRow}>
              {reason === 'details'
                ? `A payment to ${m.payee} on ${day} for $${formatCentsAsDollars(m.totalCents)} is already saved.`
                : `This receipt was already used for a payment to ${m.payee} on ${day}.`}
            </p>
          ));
        })}
      </div>
      <div className={styles.navRow}>
        <button className={styles.secondaryButton} onClick={props.onBack}>
          Go back
        </button>
        <button className={styles.primaryButton} onClick={props.onSaveAnyway}>
          Save anyway
        </button>
      </div>
    </main>
  );
}
